import { fromJS } from 'immutable';

import {
  REQUEST_FUNDING_SEARCH_OVERVIEW,
  REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS,
  REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: { loading: false, error: false },
});

export function fundingSearchOverviewRequest() {
  return {
    type: REQUEST_FUNDING_SEARCH_OVERVIEW,
  };
}

export function fundingSearchOverviewSuccess(response) {
  return {
    type: REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS,
    response,
  };
}

export function fundingSearchOverviewFailure(error) {
  return {
    type: REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE,
    error,
  };
}

export default function fundingSearchOverviewReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_FUNDING_SEARCH_OVERVIEW:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );
    default:
      return state;
  }
}
